module.exports = __webpack_public_path__ + "bd626b69f7d1d5d30fd95294de36ce2a.png";